import React from "react";
import { Icon } from "@iconify/react";

/**
 * One panel of the Analytics console.
 *
 * 🔴 DELIBERATELY DOES NOT COLLAPSE, and that is the difference from
 * SettingsSection. Settings can hide a drawer safely because an operator
 * arrives already knowing which switch they came to flip. Analytics is read to
 * find out WHETHER THE PRODUCT IS WORKING, so the operator does not yet know
 * which number matters today, and a shut drawer here is a number nobody looked
 * at. Same shell, opposite behaviour.
 *
 * WHAT THIS REPLACES. The page carried three incompatible heading rules:
 *   - `<h6 className="mb-0">` inside a d-flex row, faked in the card BODY
 *     (LoopFunnel, CuriouzzPromise, RevealLimbo, CallPattern)
 *   - `<li className="fw-bold mb-0 list-unstyled">` with no <ul> around it,
 *     inside the component's OWN nested Bootstrap card, which sat inside the
 *     page's card and produced a double border and double padding
 *     (AnalyticsPage, FunnelAnalyticsPage)
 *   - no heading whatsoever (ChatConversionStats)
 * All three become one real `<h5 className="fw-semibold">` in one real
 * `.card-header`, which is what picks up Sora and the brand letter-spacing
 * from App.css without a line of new type CSS.
 *
 * `basis` is the line that states what the numbers count: the window, the
 * exclusions, the denominator. On a reading surface that NEVER goes behind a
 * hover, because a percentage whose basis is hidden is how the same figure
 * ends up quoted two different ways in one meeting. Only definitions and
 * methodology may hover.
 */
const AnalyticsSection = ({ id, icon, title, basis, right, children }) => (
  <section className="row gy-4 mt-1">
    <div className="col-12">
      <div className="card" data-panel={id}>
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center gap-3">
          <span
            className="w-40-px h-40-px radius-8 d-flex justify-content-center align-items-center flex-shrink-0"
            style={{
              background: "rgba(140, 80, 253, 0.08)",
              border: "1px solid rgba(140, 80, 253, 0.18)",
            }}
            aria-hidden="true"
          >
            <Icon
              icon={icon}
              style={{ fontSize: "1.125rem", color: "var(--cz-purple, #8c50fd)" }}
            />
          </span>

          <h5 className="fw-semibold mb-0 flex-grow-1" style={{ minWidth: 0 }}>
            {title}
          </h5>

          {right && <div className="flex-shrink-0">{right}</div>}
        </div>

        <div className="card-body">
          {basis && (
            <p className="text-sm text-secondary-light mb-3" style={{ maxWidth: "72ch" }}>
              {basis}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>
  </section>
);

export default AnalyticsSection;
